import '@aab/sc-aab-modal';
import { forwardRef, MutableRefObject, ReactNode, useEffect } from 'react';

type ModalProps = {
  title?: ReactNode;
  content?: ReactNode;
  footer?: ReactNode;
  size?: 'small' | 'medium' | 'large';
  onClose?: () => void;
};

export const Modal = forwardRef<HTMLElement, ModalProps>(
  ({ title, content, footer, size = 'small', onClose }, ref) => {
    useEffect(() => {
      const element = (ref as MutableRefObject<ModalHTMLElement>)?.current;

      if (ref && element && onClose) {
        element.addEventListener('modal-close', onClose);
      }
      return () => {
        if (ref && element && onClose) {
          return element.removeEventListener('modal-close', onClose);
        }
        return undefined;
      };
    }, [ref]);
    return (
      <aab-modal modal-size={size} open="true" ref={ref}>
        {title && (
          <div className="flex ai-center" slot="modal-title">
            {title}
          </div>
        )}
        {content && <div slot="modal-content">{content}</div>}
        {footer && (
          <div className="flex jc-end" slot="modal-footer">
            {footer}
          </div>
        )}
      </aab-modal>
    );
  }
);
